import React from 'react';

import { QueryInstanceSearchOptions } from '@lumapps/instance/api/types';
import { useQueryInstanceSearch } from '@lumapps/instance/hooks/useQueryInstanceSearch';

const MAX_RESULTS = 20;

/**
 * Hook that returns the different options needed for listing instances in the picker field
 */
export const useInstancePickerState = (params?: Partial<QueryInstanceSearchOptions>, instancesToExclude?: string[]) => {
    const [searchValue, setSearchValue] = React.useState<string | undefined>();
    const [enabled, setEnabled] = React.useState(false);
    const query = useQueryInstanceSearch(
        {
            userFavoritesOnly: false,
            maxResults: MAX_RESULTS,
            sortOrder: 'name',
            ...params,
            name: searchValue || undefined,
        },
        { enabled },
    );

    /**
     * Remove the ids from the instances passed in `instancesToExclude` and return the actually filtered list.
     */
    const filteredSites = React.useMemo(() => {
        if (instancesToExclude && instancesToExclude.length > 0) {
            return query.items.filter((site) => !instancesToExclude.includes(site.id));
        }
        return query.items;
    }, [instancesToExclude, query.items]);

    return {
        sites: filteredSites,
        status: query.baseLoadingStatus,
        onSearch: setSearchValue,
        onInfiniteScroll: () => query.hasNextPage && query.fetchNextPage(),
        onFocus: () => setEnabled(true),
    };
};
